export default __webpack_public_path__ + "static/media/goods1.86bea7ae.gif";